module.exports = __webpack_public_path__ + "img/storage.78a6a112.svg";